import { useTranslation } from 'react-i18next'

import { TertiaryButton } from '@enechain/ecloud-designsystem'

import { CompactAlert } from '~/components/common/CompactAlert'

type Props = {
  /**
   * 恒久的に表示できない (NotFound) か。BFF は対象組織外・kind 不一致も NotFound で
   * マスクするため、通信・サーバーエラーとは文言を分ける。
   */
  isNotFound: boolean
  /** 再読み込み中か (ボタンを loading にする)。 */
  isReloading: boolean
  /** 再読み込み。取得し直しても意味が無い時 (URL 不正等) は渡さず、ボタンを出さない。 */
  onReload?: () => void
}

/**
 * 詳細画面の初回取得失敗の表示 (AC-PPD-001a)。ヘッダー・フィルタバー・テーブルの代わりに
 * エラーの Alert だけを画面の上部に出す。版の詳細と提出記録の無い計画の詳細
 * (AC-PPD-028) で共通。
 *
 * 再読み込みは Alert の中の右端の Tertiary sm (UI 辞書 components/alert-placement.md §4)。
 */
export const DetailFetchError = ({
  isNotFound,
  isReloading,
  onReload,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <CompactAlert
      status="error"
      title={
        isNotFound
          ? t('page:procurementPlanDetail.error.notFound')
          : t('page:procurementPlanDetail.error.fetchFailed')
      }
    >
      {onReload !== undefined && (
        <TertiaryButton loading={isReloading} onClick={onReload} size="sm">
          {t('page:procurementPlanDetail.error.reload')}
        </TertiaryButton>
      )}
    </CompactAlert>
  )
}
